import moment from 'moment';
import React from 'react';

import { DEFAULT_NULL_VALUE } from '@/src/components/project/Inbox2/Config/inbox.config';

type FormattedDateProps = {
  value: string;
  format?: string;
};

export const DEFAULT_DATE_FORMAT = 'DD-MMM YYYY hh:mm A';

const FormattedDate = ({ value, format = DEFAULT_DATE_FORMAT }: FormattedDateProps) => {
  if (!value || value === DEFAULT_NULL_VALUE) {
    return <React.Fragment>{DEFAULT_NULL_VALUE}</React.Fragment>;
  }

  if (!moment(value).isValid()) {
    throw new Error('Invalid Date');
  }

  const formattedDate = moment(value).format(format);

  return <React.Fragment>{formattedDate}</React.Fragment>;
};

export default FormattedDate;
